"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('dotenv').config();
var HOSTS = {
    development: {
        application: 'https://app.listen360.localhost',
        api: 'https://app2.listen360.localhost',
        apiV2: 'https://api.listen360.localhost'
    },
    test: {
        application: 'http://localhost:3005',
        api: 'http://localhost:3002',
        apiV2: 'http://localhost:3007'
    },
    production: {
        application: 'https://app.listen360.com',
        api: 'https://app2.listen360.com',
        apiV2: 'https://api.listen360.com'
    },
    sandbox: {
        application: 'https://sandbox.listen360.com',
        api: 'https://app2-sandbox.listen360.com',
        apiV2: 'https://api-sandbox.listen360.com'
    },
    staging: {
        application: 'https://staging.listen360.com',
        api: 'https://app2-staging.listen360.com',
        apiV2: 'https://api-staging.listen360.com'
    }
};
var config = {
    hosts: HOSTS,
    applicationBaseUrl: HOSTS[process.env.NODE_ENV].application,
    apiBaseUrl: HOSTS[process.env.NODE_ENV].api + "/api",
    apiBaseUrlV2: HOSTS[process.env.NODE_ENV].apiV2 + "/v2"
};
exports.default = config;
//# sourceMappingURL=config.js.map